import { setBlur, setDisplay } from "./domHelpers.js";

export const showOverlay = (preloader, blurred = []) => {
  setDisplay(preloader, "flex");
  setBlur(blurred, 5);
};

export const hideOverlay = (preloader, blurred = []) => {
  setDisplay(preloader, "none");
  setBlur(blurred, 0);
};

export const onAsyncAction = async (preloader, blurred, action) => {
  try {
    showOverlay(preloader, blurred);
    return await action();
  } finally {
    hideOverlay(preloader, blurred);
  }
};



